import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { clsx } from 'clsx';

import { PublicProductCard } from '../../components/shared/PublicProductCard';
import { WishlistButton } from '../../components/shared/WishlistButton';
import { WishlistCollectionManagerButton } from '../../components/shared/WishlistCollectionManagerButton';
import { CartonProduct } from '../../types';

interface Props {
    product: CartonProduct;
    loading: boolean;
    eagerLoadImage: boolean;
    showUniverseBadge?: boolean;
    manageWishlistCollections?: boolean;
}

export const ProductCardLink: FC<Props> = ({
    product,
    loading,
    eagerLoadImage,
    showUniverseBadge = false,
    manageWishlistCollections = false,
}) => {
    return (
        <div className="group relative">
            <Link
                className={clsx({ 'pointer-events-none': loading })}
                href={product.url_path}
            >
                <PublicProductCard
                    product={product}
                    loading={loading}
                    eagerLoadImage={eagerLoadImage}
                    showUniverseBadge={showUniverseBadge}
                />
            </Link>
            <WishlistButton
                productId={product.id}
                initialWishlisted={product.wishlisted}
                className="absolute top-2 right-2 z-10 h-8 w-8"
            />
            {manageWishlistCollections && (
                <WishlistCollectionManagerButton
                    productId={product.id}
                    className="absolute top-2 left-2 z-10 h-8 w-8"
                />
            )}
        </div>
    );
};
